import Swiper from "swiper";
import { EffectFade } from "swiper/modules";
import { gsap, Power4 } from "gsap";
import SplitType from "split-type";

const heroHomepage = () => {
    let swiperImagesInit = false;
    let swiperCardsInit = false;
    let currentSlide = 0;

    const cards = document.querySelector(".hero-homepage__cards");
    const images = document.querySelector(".hero-homepage__images");
    const triggers = document.querySelectorAll(".hero-homepage__trigger");
    const pagination = document.querySelectorAll(".hero-homepage__page");

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    currentSlide = parseInt(entry.target.dataset.slide);

                    // Update pagination
                    pagination.forEach((page, i) => {
                        currentSlide === i
                            ? pagination[i].classList.add("is-active")
                            : pagination[i].classList.remove("is-active");
                    });

                    // Toggle active slide for each swiper instance
                    sliderCards.slideTo(currentSlide);
                    sliderImages.slideTo(currentSlide);
                }
            });
        },
        {
            root: null,
            rootMargin: "0px 0px -50% 0px",
            threshold: 0.5,
        }
    );

    triggers.forEach(trigger => {
        observer.observe(trigger);
    });

    const sliderImages = new Swiper(images, {
        modules: [EffectFade],
        allowTouchMove: false,
        speed: 1000,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        keyboard: false,
        a11y: false,
        runCallbacksOnInit: false,
        touchStartPreventDefault: false,
        preventClicks: true,
        preventClicksPropagation: true,
        slideToClickedSlide: false,
        on: {
            init: () => {
                swiperImagesInit = true;
            },
        },
    });

    const sliderCards = new Swiper(cards, {
        allowTouchMove: false,
        direction: "vertical",
        speed: 1000,
        keyboard: false,
        a11y: false,
        runCallbacksOnInit: false,
        touchStartPreventDefault: false,
        preventClicks: true,
        preventClicksPropagation: true,
        slideToClickedSlide: false,
        on: {
            init: () => {
                swiperCardsInit = true;
                swiperImagesInit && swiperCardsInit && window.innerWidth > 480 && animateIn();
            },
        },
    });
};

const animateIn = () => {
    // When we're all initialised, let's animate in.

    const title = document.querySelector(".hero-homepage__split");
    const description = document.querySelector(".hero-homepage__description");
    const buttons = document.querySelectorAll(".hero-homepage__buttons button");
    const bgs = document.querySelectorAll(".hero-homepage__bg img");
    const cards = document.querySelectorAll(".hero-homepage__slide");

    const titleSplit = new SplitType(title, { types: ["word", "chars"] });
    titleSplit.words.forEach(word => {
        word.setAttribute("aria-hidden", true);
    });

    const tl = gsap.timeline({
        defaults: {
            duration: 0.6,
            ease: Power4.easeOut,
        },
    });

    gsap.set(".hero-homepage .preset", { autoAlpha: 1 });

    tl.from(titleSplit.chars, {
        y: "100%",
        autoAlpha: 0,
        stagger: 0.01,
    });

    tl.from(
        description,
        {
            autoAlpha: 0,
            y: 30,
        },
        "-=75%"
    );

    tl.from(
        buttons,
        {
            autoAlpha: 0,
            y: 30,
            stagger: 0.05,
        },
        "-=75%"
    );

    tl.addLabel("fadeIn", "-=.3");

    tl.fromTo(
        cards,
        {
            y: document.documentElement.clientHeight / 1.3,
            scale: 0.6,
        },
        {
            y: 0,
            scale: 1,
            duration: 2,
            ease: Power4.easeOut,
        },
        "fadeIn-=.2"
    );
    tl.to(
        bgs,
        {
            autoAlpha: 0.4,
            duration: 4,
            ease: Power4.easeOut,
            blur: 10,
        },
        "fadeIn"
    );
};

export default heroHomepage;
